import Vue from "vue";
import VueRouter from "vue-router";

//A-Z
//import Default from "@/module/Home/page/Default.vue";
import SearchPage from "@/module/SearchList/page/SearchPage.vue";
import Notfound from "@/module/Static/page/NotFound.vue";
import Flashsale from "@/module/List/page/Flashsale.vue";
import Pdpa from "@/module/Static/page/Pdpa.vue";
import ContactUs from '@/module/ContactUs/page/ContactUs.vue'
import Faq from '@/module/Faq/page/Faq.vue'
import LanguagePage from '@/module/LanguagePage/page/LanguagePage.vue'
import PrivacySetting from '@/module/PrivacySetting/page/PrivacySetting.vue'
import Register from '@/module/Register/page/Register.vue'
import Login from '@/module/Login/page/Login.vue';
import Logout from '@/module/Logout/page/Logout.vue';
import MyProfile from '@/module/MyProfile/page/MyProfile.vue'
import Errorpage from "@/module/Static/page/Errorpage.vue";
import ChangePassword from "@/module/ChangePassword/page/ChangePassword.vue";
import ForgetPassword from '@/module/ForgotPassword/page/ForgetPassword.vue';
import CreateNewPassword from '@/module/ForgotPassword/page/CreateNewPassword.vue'
import MyAccount from '@/components/Layout/Page/MyAccount.vue';

import NewCampaign from '../module/Detail_New/page/Campaign.vue'
import NewHome from '../module/Home/page/NewHome.vue';
Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'default',
        component: NewHome,
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
    },
    {
        path: '/logout',
        name: 'Logout',
        component: Logout,
    },
    {
        path: '/search/:keyword?',
        name: "Search",
        component: SearchPage,
    },
    {
        path: '/home',
        name: 'Home',
        component: NewHome,
    },
    {
        path: '/campaign/:campaignId',
        name: 'campaign',
        component: NewCampaign,
    },
    {
        path: '/flashsale',
        name: 'flashsale',
        component: Flashsale,
    },
    {
        path: '/flashsale/campaign/:campaignId',
        name: 'campaignflashsale',
        component: NewCampaign,
    },
    {
        path: '/main/contactus',
        name: 'Contact Us',
        component: ContactUs
    },
    {
        path: '/main/faq',
        name: 'FAQ',
        component: Faq
    },
    {
        path: '/main/language',
        name: 'Language',
        component: LanguagePage
    },
    {
        path: '/register',
        name: 'register',
        component: Register
    },
    {
        path: '/main/privacysetting/:type?',
        name: 'Privacy Setting',
        component: PrivacySetting
    },
    {
        path: '/terms',
        name: 'terms',
        component: Pdpa,
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: Pdpa,
    },
    {
        path: '/marketing',
        name: 'marketing',
        component: Pdpa,
    },
    {
        path: '/main/myprofile',
        name: 'My Profile',
        component: MyProfile
    },
    {
        path: '/error',
        name: 'errorpage',
        component: Errorpage,
    },
    {
        path: '/main/changepassword',
        name: 'Change password',
        component: ChangePassword,
    },
    {
        path: '/forgetpassword',
        name: 'forget password',
        component: ForgetPassword,
    },
    {
        path: '/resetpassword',
        name: 'resetpassword',
        component: CreateNewPassword,
    },
    {
        path: '/main',
        name: 'main',
        component: MyAccount,
    },
    {
        path: '*',
        name: 'notfound',
        component: Notfound,
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;
